import React, { useEffect, useRef, useState, useCallback } from "react";
import {
  DataGrid,
  GridColDef,
  GridToolbar,
  GridOverlay,
} from "@mui/x-data-grid";
import {
  Button,
  Typography,
  Box,
  Grid,
  styled,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import ToastSnackbar, { SnackbarHandle } from "../../common/ToastNotification";
import ProfileDialogStudentDetailsAdmin from "../../components/ProfileDialogStudentDetailsAdmin";
import HomeIcon from "@mui/icons-material/Home";
import { students_empty } from "../../Config/students";

import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";

import { ListStudentsForTC } from "../../api/Students-Management/add-view-students";
import { Get as GetClass } from "../../api/Control-Settings/manage-class";
import { GetSections } from "../../api/Exams-Management/manage-section";
import { GetSchedulesForClass } from "../../api/Exams-Management/schedule-exam";
import { v4 as uuid } from "uuid";
import { GetExams } from "../../api/Exams-Management/new_exam";
import { deleteFile, uploadFile, UploadFileType } from "../../api/upload";
import { useForm } from "react-hook-form";
import ControlledSelect from "../../common/ControlledComponents/ControlledSelect";
import ControlledTextField from "../../common/ControlledComponents/ControlledTextField";
import {
  dateToWords,
  DEFAULT_LOGGED_USER,
  extractClassLevel,
  getPastAcademicYearsList,
} from "../../helper/helper";
import { useApi, useUser } from "../../store/UserLoginContext";
import { getCurrentUser } from "../../service/authService";
import PrintTCDialogBox from "./printTCDialogBox";
import moment from "moment";
import { GetSubjectsToClassFilteredv2 } from "../../api/Control-Settings/manage-subjects";
import { GetTcCount } from "../../api/TC/issueTC";

const CustomNoRowsOverlay = ({ loading }: { loading: boolean }) => {
  return (
    <GridOverlay
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <Box sx={{ textAlign: "center", padding: 2 }}>
        {loading ? (
          <>
            <CircularProgress size={40} />
            <Typography variant="h6" color="textSecondary" mt={2}>
              Loading data...
            </Typography>
          </>
        ) : (
          <Typography variant="h5" color="textSecondary">
            NO DATA AVAILABLE
          </Typography>
        )}
      </Box>
    </GridOverlay>
  );
};
// Create buttons with hover underline animation
const AnimatedButton = ({
  label,
  onClick,
  disabled,
}: {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}) => {
  return (
    <Button
      variant="text"
      onClick={onClick}
      sx={{
        position: "relative",
        // fontFamily: "Motiva Sans Bold",
        // fontWeight: "Bold",
        padding: "0 10px",
        fontSize: "14px",
        textTransform: "none",
        color: "#2e186a",
        "&:hover": {
          fontWeight: "Bold",
        },
        "&::after": {
          content: '""',
          fontWeight: "Bold",
          position: "absolute",
          width: "0",
          height: "2px",
          left: "0",
          bottom: "-2px",
          backgroundColor: "rgb(255, 130, 92)",
          transition: "width 0.3s ease-in-out",
        },
        "&:hover::after": {
          width: "100%", // Underline expands on hover
        },
      }}
      disabled={disabled == null ? true : disabled}
    >
      <strong>{label}</strong>
    </Button>
  );
};

const romanToClass = {
  LKG: "LKG",
  UKG: "UKG",
  I: "1st",
  II: "2nd",
  III: "3rd",
  IV: "4th",
  V: "5th",
  VI: "6th",
  VII: "7th",
  VIII: "8th",
  IX: "9th",
  X: "10th",
  // "X (HINDI)": "10th",
  // "X (SANSKRIT)": "10th",
  XI: "11th",
  // "XI (MATHS)": "11th",
  // "XI (BIO.)": "11th",
  XII: "12th",
  // "XII (MATHS)": "12th",
  // "XII (BIO.)": "12th",
};

const MyCustomButton = styled(Button)(({ theme }) => ({
  fontFamily: "Motiva Sans Bold",
  fontSize: "0.80rem",
  fontWeight: "700",
  border: "1px solid #edf3f5",
  borderRadius: "4px",
  background: "#2e186a",
  boxShadow: "0 16px 30px rgb(23 31 114 / 20%)",
  marginTop: "0rem",
  "&:hover": {
    color: "#fff",
    border: "1px solid rgb(255, 130, 92)",
    backgroundColor: "rgb(255, 130, 92)",
  },
}));

const IssueTC = () => {
  const { currentSessionAY } = useApi();
  const { user } = useUser();
  const navigate = useNavigate();
  const [applications, setApplications] = useState<any>([]);

  const [isProfileDialogOpen, setProfileDialogOpen] = useState(false);

  const [isEditing, setIsEditing] = useState(false);
  const resetFormRef = useRef<() => void>(() => {});

  const snackbarRef = useRef<SnackbarHandle>(null);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [addNewStudent, setAddNewStudent] = useState<boolean>(false);

  const [classList, setClassList] = useState<any>([]);
  const [filteredClassList, setFilteredClassList] = useState<any>([]);
  const [sectionList, setSectionList] = useState<any>([]);

  const [loading, setLoading] = useState(true);
  const [adding, setAdding] = useState(false);
  const [fetching, setFetching] = useState(false);

  const [loggedInUser, setLoggedInUser] = useState("");
  const [tcdata, setTcdata] = useState<any>({});
  const [academicYears, setAcademicYears] = useState<any>([]);
  const [formattedAY, setFormattedAY] = useState("");
  const [subjectList, setSubjectList] = useState<any>([]);
  const [selectedAY, setSelectedAY] = useState("");
  const [dateOfIssue, setDateOfIssue] = useState<any>(null);
  const [dateOfApplication, setDateOfApplication] = useState<any>(null);
  const [processingRowId, setProcessingRowId] = useState<any>(null);

  const [certType, setCertType] = useState("");
  useEffect(() => {
    const { username } = getCurrentUser();
    setLoggedInUser(username);
  }, []);

  const {
    handleSubmit,
    setError,
    reset,
    setValue,
    formState: { errors },
    control,
    watch,
    trigger,
  } = useForm({
    defaultValues: {
      admission_id: "",
      name: "",
      class_id: "",
      section_id: "",
      academic_year: "",
      date_of_issue: "",
      date_of_application: "",
    },
    mode: "onTouched",
  });

  useEffect(() => {
    currentSessionAY && setValue("academic_year", currentSessionAY);
  }, [currentSessionAY, setValue]);

  const dateOfIssueWatch = watch("date_of_issue");
  const dateOfApplicationWatch = watch("date_of_application");

  useEffect(() => {
    setDateOfApplication(
      moment(dateOfApplicationWatch, "YYYY-MM-DD").format("DD-MM-YYYY")
    );
    setDateOfIssue(moment(dateOfIssueWatch, "YYYY-MM-DD").format("DD-MM-YYYY"));
    // console.log(dateOfApplicationWatch);
    // console.log(dateOfIssueWatch);
  }, [dateOfApplicationWatch, dateOfIssueWatch]);

  const onClose = () => {
    if (resetFormRef.current) {
      resetFormRef.current(); // Reset the form to its initial state
    }
    setProfileDialogOpen(false);
    setIsEditing(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [classes_records, section_records] = await Promise.all([
          GetClass(),
          GetSections(),
        ]);

        if (classes_records && classes_records.result.documents?.length > 0) {
          setClassList(classes_records.result.documents);
        }
        if (section_records && section_records.result.documents?.length > 0) {
          setSectionList(section_records.result.documents);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        snackbarRef.current?.showSnackbar(`Error fetching data`, "error");
      } finally {
        setLoading(false);
      }
    };
    console.log("******** USER FETCHED AS BELOW ************* ");
    console.log(user?.username);
    fetchData();
    setAcademicYears(getPastAcademicYearsList());
  }, []);

  const JSONParseStudentObject = (student_string: any) => {
    try {
      const student_json_parsed = student_string.map((stud: any) => ({
        ...stud,
        transport_details: JSON.parse(stud.transport_details),
        personal_details: JSON.parse(stud.personal_details),
        guardian_details: JSON.parse(stud.guardian_details),
        father_details: JSON.parse(stud.father_details),
        mother_details: JSON.parse(stud.mother_details),
        previous_school: JSON.parse(stud.previous_school),
      }));

      return student_json_parsed;
    } catch (error) {
      console.log("Error JSON parsing student object");
      console.log(error);
      return [];
    }
  };

  // const CreateSubjectString = (class_name: string) => {
  //   const _subject = [...subjectList];
  //   if (class_name === "XII (Maths)") {
  //     let index = _subject.indexOf("BIOLOGY");
  //     if (index !== -1) {
  //       _subject[index] = "MATHS";
  //     }
  //   }
  //   if (class_name === "XII (Bio.)") {
  //     let index = _subject.indexOf("MATHS");
  //     if (index !== -1) {
  //       _subject[index] = "BIOLOGY";
  //     }
  //   }
  //   if (class_name === "X (Hindi)") {
  //     let index = _subject.indexOf("SANSKRIT");
  //     if (index !== -1) {
  //       _subject[index] = "HINDI";
  //     }
  //   }
  //   if (class_name === "X (Sanskrit)") {
  //     let index = _subject.indexOf("HINDI");
  //     if (index !== -1) {
  //       _subject[index] = "SANSKRIT";
  //     }
  //   }

  //   return _subject.join(", ");
  // };

  const handleGenerateTC = async (student: any) => {
    console.log("Generate TC Clicked For");
    console.log(student);

    try {
      setProcessingRowId(student.student_id);

      const selected_classid = student.class_id;
      const selected_sectionid = student.section_id;

      const payload = {
        class_id: selected_classid,
        section_id: selected_sectionid,
      };

      const subject_to_class_records = await GetSubjectsToClassFilteredv2(
        payload
      );

      console.log("**** subject_to_class_records *****");
      console.log(subject_to_class_records);
      if (
        !subject_to_class_records ||
        subject_to_class_records?.result?.total === 0
      ) {
        snackbarRef.current?.showSnackbar(
          `Subjects not assigned to this student`,
          "warning"
        );
        return;
      }

      const subjects_str =
        subject_to_class_records?.result?.documents[0]?.subjects || undefined;

      if (!subjects_str) {
        snackbarRef.current?.showSnackbar(
          `Subjects not assigned to this student`,
          "warning"
        );
        return;
      }
      let subject_json = JSON.parse(subjects_str);

      let subjectList = subject_json.map((item: any) => item.subject_name);

      let _CertNo = "";
      let tcCounterId = "";
      if (student.tc_number) {
        console.log("**** TC NUMBER ALREADY PRESENT ****");
        _CertNo = student.tc_number;
      } else {
        console.log("**** TC NUMBER NOT PRESENT ****");
        const tc_count_response = await GetTcCount(selectedAY);

        console.log("**** DB TC COUNT RESPONSE ****");
        console.log(tc_count_response);

        if (tc_count_response && tc_count_response?.result?.total > 0) {
          console.log(tc_count_response?.result?.documents[0]?.tc_counter);
          let tc_counter_db =
            tc_count_response?.result?.documents[0]?.tc_counter ?? null;
          if (tc_counter_db >= 0) {
            tcCounterId = tc_count_response?.result?.documents[0]?.$id || null;
            const current_tc_counter = tc_counter_db + 1;
            _CertNo = `${DEFAULT_LOGGED_USER.toUpperCase()}/${formattedAY}/${current_tc_counter
              .toString()
              .padStart(3, "0")}`;
          } else {
            _CertNo = `${DEFAULT_LOGGED_USER.toUpperCase()}/${formattedAY}/${""
              .toString()
              .padStart(3, "0")}`;
            snackbarRef.current?.showSnackbar(
              `Unable to generate TC number. Proceed manually. Share TC details with developer to update database.`,
              "error"
            );
          }
        } else {
          _CertNo = `${DEFAULT_LOGGED_USER.toUpperCase()}/${formattedAY}/${""
            .toString()
            .padStart(3, "0")}`;
          snackbarRef.current?.showSnackbar(
            `Unable to generate TC number. Proceed manually. Share TC details with developer to update database.`,
            "error"
          );
        }
      }

      // let certNoArray: number[] = [];

      // applications.forEach((element: any) => {
      //   if (element.tc_number) {
      //     const certNo = element.tc_number.split("/")[2];
      //     certNoArray.push(parseInt(certNo));
      //   }
      // });

      // let max = 1;
      // if (certNoArray.length > 0) {
      //   max += Math.max(...certNoArray);
      //   console.log(max);
      // }

      const tcDataObject = {
        id: student.student_id,
        tcCounterId: tcCounterId,
        loggedInUser: loggedInUser,
        name: student.personal_details?.name || "N/A",
        motherName: student.mother_details?.name || "N/A",
        fatherName: student.father_details?.name || "N/A",
        nationality: "INDIAN",
        dob: student.personal_details?.dob
          ? moment(student.personal_details?.dob, "DD-MM-YYYY").format(
              "DD-MM-YYYY"
            )
          : "N/A",
        "(in words)": `${dateToWords(
          moment(student.personal_details?.dob, "DD-MM-YYYY").format(
            "DD-MM-YYYY"
          )
        )}`,
        casteStatus: "---",
        // (student?.cast === "SC" || student?.cast) === "SC" ? "YES" : "NO",
        date_of_adm_class: `${
          student?.admission_date
            ? moment(student.admission_date, "DD-MM-YYYY").format("DD-MM-YYYY")
            : "N/A"
        } / ${student?.admission_class || "NA"}`,

        lastClass: student?.class_name
          ? //@ts-ignore
            romanToClass[student?.class_name.toUpperCase()]
          : "N/A",
        lastExamResult:
          student?.anual_outcome.toUpperCase() === "FAIL"
            ? student?.class_name === "XII"
              ? `AISSCE - COMPART ${selectedAY ? selectedAY.split("-")[1] : ""}`
              : `AISSE - COMPART ${selectedAY ? selectedAY.split("-")[1] : ""}`
            : student?.class_name === "XII"
            ? `AISSCE - ${selectedAY ? selectedAY.split("-")[1] : ""}`
            : `AISSE - ${selectedAY ? selectedAY.split("-")[1] : ""}`,
        // lastExamResult:
        //   student?.annual_outcome.toUpperCase() === "FAIL"
        //     ? `COMPART`
        //     : student?.class_name === "XII"
        //     ? `AISSCE - ${selectedAY ? selectedAY.split("-")[1] : ""}`
        //     : `AISSE - ${selectedAY ? selectedAY.split("-")[1] : ""}`,

        //`AISSE - ${selectedAY ? selectedAY.split("-")[0] : ""}`,
        failHistory: "NO",
        subjects: subjectList.join(", "), //CreateSubjectString(student?.class_name),
        //subjectList.join(", "),
        qualified_for_promotion: "YES",
        promotionClass:
          student.class_name === "X"
            ? "XI"
            : student?.class_name === "XII"
            ? "GRADUATION"
            : "",
        feesPaidTill: `MARCH - ${selectedAY ? selectedAY.split("-")[1] : ""}`,
        feeConcession: "NO",
        totalWorkingDays: student?.totalWorkingDays || "",
        totalPresentDays: student?.totalPresentDays || "",
        nccDetails: "NO",
        activities: "NO",
        conduct: "GOOD",
        applicationDate: student?.applicationDate
          ? student?.applicationDate
          : dateOfApplication === "Invalid date"
          ? ""
          : dateOfApplication,
        // applicationDate:
        //   dateOfApplication === "Invalid date" ? "" : dateOfApplication,
        issueDate: student?.tc_issue_date
          ? student?.tc_issue_date
          : dateOfIssue === "Invalid date"
          ? ""
          : dateOfIssue,
        prevIssueDate: student?.tc_issue_date || "",
        // applicationDate_custom:
        //   dateOfApplication === "Invalid date" ? "" : dateOfApplication,
        // issueDate_custom: dateOfIssue === "Invalid date" ? "" : dateOfIssue,
        reasonLeaving:
          student.class_name === "X"
            ? "ON PARENT REQUEST"
            : student?.class_name === "XII"
            ? "HIGHER EDUCATION"
            : "",
        remark: "---",
        certNo: _CertNo,
        // certNo: student.tc_number
        //   ? student.tc_number
        //   : `ANKURAMVP/${formattedAY}/${max.toString().padStart(3, "0")}`,
        certIssued: student.tc_number ? true : false,
        admNo: student?.admission_id
          ? student?.admission_id.toString().padStart(6, "0")
          : "",
        regNo: student?.board_reg_no || "",
        rollNo: student?.board_roll_no || "",
        anual_outcome: student?.anual_outcome || "",
      };

      console.log(tcDataObject);

      setCertType("TC");
      setTcdata(tcDataObject);
      setProfileDialogOpen(true);
    } catch (error) {
      snackbarRef.current?.showSnackbar(`TC processing error.`, "error");
    } finally {
      setProcessingRowId(null);
    }
  };

  const handleGenerateCharacterCert = async (student: any) => {
    console.log("Generate Character certificate Clicked");
    console.log(student);

    try {
      const tcDataObject = {
        name: student.personal_details?.name || "N/A",
        motherName: student.mother_details?.name || "N/A",
        fatherName: student.father_details?.name || "N/A",

        date_of_adm_class: `${
          student?.admission_date
            ? moment(student.admission_date, "DD-MM-YYYY").format("DD-MM-YYYY")
            : "N/A"
        }/${student?.admission_class || "NA"}`,

        lastClass: student?.class_name
          ? //@ts-ignore
            romanToClass[student?.class_name.toUpperCase()]
          : "N/A",
        separationDate: `31-Mar-${selectedAY ? selectedAY.split("-")[1] : ""}`,
        certNo: student.tc_number ? student.tc_number : "",
        admNo: student?.admission_id || "",
        regNo: student?.board_reg_no || "",
        rollNo: student?.board_roll_no || "",
        issueDate: student?.tc_issue_date || "",
      };

      console.log(tcDataObject);

      setCertType("CHARACTER");
      setTcdata(tcDataObject);
      setProfileDialogOpen(true);
    } catch (error) {
      console.log(error);
    }
  };

  // Define columns with DataGrid
  const columns: GridColDef[] = [
    {
      field: "admission_id",
      headerName: "Adm ID",
      flex: 0.5,
      valueGetter: (_, row) => {
        return row.admission_id.toString().padStart(6, "0");
      },
    },
    {
      field: "personal_details",
      headerName: "Name",
      flex: 1,
      valueGetter: (_, row) => row.personal_details.name,
    },
    {
      field: "parent_details",
      headerName: "Father's Name",
      flex: 1.2,
      valueGetter: (_, row) => row.father_details.name,
    },
    // {
    //   field: "class",
    //   headerName: "Class",
    //   flex: 0.5,
    //   valueGetter: (_, row) => {
    //     return `${row.class_name}(${row.section_name})`;
    //   },
    // },
    {
      field: "board_roll_no",
      headerName: "Board Roll No",
      flex: 0.7,
      valueGetter: (_, row) => row.board_roll_no || "N/A",
    },
    {
      field: "board_reg_no",
      headerName: "Board Reg",
      flex: 0.7,
      valueGetter: (_, row) => row.board_reg_no || "N/A",
    },
    {
      field: "tc_number",
      headerName: "Cert No",
      flex: 0.8,
      valueGetter: (_, row) => row.tc_number || "N/A",
      // valueGetter: (_, row) => {
      //   const sectionItem = sectionList.find(
      //     (item: any) => item.section_id === row.academic_records[0]?.section_id
      //   );

      //   if (sectionItem) return sectionItem.name;
      // },
    },
    {
      field: "tc_issue_date",
      headerName: "Issued On",
      flex: 0.8,
      valueGetter: (_, row) => row.tc_issue_date || "N/A",
      // valueGetter: (_, row) => row.academic_records[0]?.roll_number,
    },

    {
      field: "actions",
      headerName: "Actions",
      flex: 2,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <>
          {processingRowId === params.row.student_id ? (
            <CircularProgress size={20} style={{ paddingTop: 2 }} />
          ) : (
            <AnimatedButton
              label={!!!params.row.tc_number ? "Generate TC" : "Print TC"}
              onClick={() => handleGenerateTC(params.row)}
              disabled={false}
            />
          )}
          {" | "}
          <AnimatedButton
            label="Character Cert"
            onClick={() => handleGenerateCharacterCert(params.row)}
            disabled={!!!params.row.tc_number}
          />
        </>
      ),
    },
  ];

  const onResetHandler = () => {
    reset({
      admission_id: "",
      name: "",
      class_id: "",
      section_id: "",
      academic_year: "",
    });
    setApplications([]);
  };

  const formatAcademicYear = (academicYear: any) => {
    const [startFull, endFull] = academicYear.split("-");
    const startShort = moment(startFull, "YYYY").format("YY");
    const endShort = moment(endFull, "YYYY").format("YY");

    return `${startShort}-${endShort}`;
  };

  const HandleFetchStudents = async (data: any) => {
    try {
      console.log("Go Clicked for Class");
      console.log(data);

      const { admission_id, class_id, section_id, academic_year, name } = data;

      const isAdmissionIdSearch = admission_id?.trim() || name?.trim();
      const isClassBasedSearch = academic_year && class_id;
      //&& section_id;

      if (!isAdmissionIdSearch && !isClassBasedSearch) {
        setError("academic_year", {
          type: "manual",
          message:
            "Required with Admission ID, Student Name OR Class and Section",
        });

        setError("name", {
          type: "manual",
          message:
            "Required with Academic Year (or leave blank if using Class & Section)",
        });

        setError("admission_id", {
          type: "manual",
          message:
            "Required with Academic Year (or leave blank if using Class & Section)",
        });

        setError("class_id", {
          type: "manual",
          message:
            "Required with Academic Year & Section (or use Admission ID)",
        });

        // setError("section_id", {
        //   type: "manual",
        //   message: "Required with Academic Year & Class (or use Admission ID)",
        // });

        return;
      }

      setFetching(true);
      setApplications([]);
      setProcessingRowId(null);
      setCertType("");
      setTcdata({});

      const payload = {
        admission_id: admission_id.trim().replace(/^0+/, ""),
        class_id,
        section_id,
        academic_year,
        name,
      };
      console.log(payload);
      const _formattedAY = formatAcademicYear(academic_year);
      const students_records = await ListStudentsForTC(payload);
      if (students_records && students_records.result.documents?.length > 0) {
        const student_string = students_records.result.documents;
        const student_json_parsed = JSONParseStudentObject(student_string);

        setApplications(student_json_parsed);
        // setSubjectList(students_records.result?.subjectList || []);
        setFormattedAY(_formattedAY);
        setSelectedAY(academic_year);
      } else {
        snackbarRef.current?.showSnackbar(`No Record Found`, "info");
      }
    } catch (error) {
      console.log(error);
      snackbarRef.current?.showSnackbar(`Some Error occured`, "error");
    } finally {
      setFetching(false);
    }
  };

  const onSuccess = (data: any) => {
    if (certType === "TC") {
      console.log("********* on Success Data ***************");
      console.log(data);

      setApplications((prev: any) =>
        prev.map((s: any) =>
          s.student_id === data.id
            ? {
                ...s,
                tc_number: data.tc_number,
                tc_issue_date: data.tc_issue_date,
                certIssued: data.tc_number ? true : false,
                applicationDate: data?.applicationDate,
              }
            : s
        )
      );
    } else if (certType === "CHARACTER") {
      console.log("CHARACTER CERTIFICATE");
    }

    // Optionally trigger a save to DB here too
  };

  const HandleAYChange = (event: any) => {
    console.log(classList);
    console.log(sectionList);

    setApplications([]);
    setProcessingRowId(null);
    setCertType("");
    setTcdata({});

    // if (event.target.value === "2024-2025") {
    //   const classList_intrim =
    //     // const classList_intrim = [
    //     //   {
    //     //     class_id: "13",
    //     //     name: "X",
    //     //   },
    //     //   {
    //     //     class_id: "16",
    //     //     name: "XII",
    //     //   },
    //     // ];

    //     setFilteredClassList(classList_intrim);
    // } else {
    //   setFilteredClassList(classList);
    // }
  };

  const HandleClassChange = (event: any) => {
    setApplications([]);
    setProcessingRowId(null);
    setCertType("");
    setTcdata({});
  };

  return (
    <>
      <ToastSnackbar ref={snackbarRef} />

      <Box
        display={"flex"}
        flexDirection={"column"}
        p={2}
        height="auto"
        // style={{ minHeight: "100vh" }}
      >
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
        >
          <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"flex-start"}
            p={2}
            pb={0}
            gap={1}
          >
            <MyCustomButton
              variant="contained"
              startIcon={<ArrowLeftIcon />}
              onClick={() => navigate("..")}
            >
              Go Back
            </MyCustomButton>
            <MyCustomButton
              variant="contained"
              startIcon={<HomeIcon />}
              onClick={() => navigate("/home")}
            >
              Home
            </MyCustomButton>
          </Box>
        </Box>

        <Grid container direction="column" mt={4}>
          <Grid item xs={12}>
            <Box
              display={"flex"}
              flexDirection={"column"}
              p={2}
              pt={0}
              height="auto"
              justifyContent={"center"}
              alignItems={"center"}
              mt={1}
            >
              <Typography variant="h5" alignSelf={"center"} mb={1}>
                <strong>Issue TC and Character Certificate</strong>
              </Typography>
              <form
                onSubmit={handleSubmit(HandleFetchStudents)}
                onReset={onResetHandler}
              >
                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  justifyContent={"space-evenly"}
                  gap={2}
                  width="90vw"
                >
                  {/* <ControlledSelect
                    name={`academic_year`}
                    control={control}
                    errors={errors}
                    label="Academic Year"
                    rules={{ required: "Academic Year is required" }}
                    options={academicYears.map((item: any) => ({
                      value: item,
                      label: item,
                    }))}
                    sx={{ width: "30%" }}
                    selectProps={{ onChange: HandleAYChange }}
                    required
                  /> */}
                  <ControlledTextField
                    name="admission_id"
                    control={control}
                    errors={errors}
                    label="Admission Id"
                    sx={{ width: "30%", mt: 0 }}
                  />
                  <ControlledTextField
                    name="name"
                    control={control}
                    errors={errors}
                    label="Student Name"
                    sx={{ width: "30%", mt: 0 }}
                  />
                  <ControlledSelect
                    name={`class_id`}
                    control={control}
                    errors={errors}
                    label="Class"
                    options={classList.map((item: any) => ({
                      value: item.class_id,
                      label: item.name,
                    }))}
                    // rules={{ required: "Required" }}
                    sx={{ width: "30%" }}
                    selectProps={{ onChange: HandleClassChange }}
                    // required
                  />
                  {/* <ControlledSelect
                    name={`section_id`}
                    control={control}
                    errors={errors}
                    label="Section"
                    options={sectionList.map((item: any) => ({
                      value: item.section_id,
                      label: item.name,
                    }))}
                    // rules={{ required: "Required" }}
                    sx={{ width: "30%" }}
                    // required
                  /> */}

                  <MyCustomButton
                    variant="contained"
                    type="submit"
                    startIcon={fetching ? <CircularProgress size={20} /> : null}
                    disabled={fetching}
                    sx={{
                      alignSelf: "center",
                      height: "70%",
                      width: "30%",
                    }}
                  >
                    {fetching ? "" : "Fetch Students"}
                  </MyCustomButton>
                  <MyCustomButton
                    variant="contained"
                    type="reset"
                    sx={{
                      alignSelf: "center",
                      height: "70%",
                      width: "30%",
                    }}
                  >
                    Clear
                  </MyCustomButton>
                </Box>
              </form>
              <form>
                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  justifyContent={"space-evenly"}
                  gap={2}
                  width="90vw"
                >
                  <Box
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"flex-start"}
                    alignItems={"center"}
                    gap={1}
                    mt={3}
                  >
                    <Typography variant="body2" pt={0}>
                      <strong>Date of Application for Certificate: </strong>
                    </Typography>
                    <ControlledTextField
                      name="date_of_application"
                      control={control}
                      errors={errors}
                      type="date"
                      sx={{ width: "34%" }}
                      required
                    />
                  </Box>
                  <Box
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"flex-start"}
                    alignItems={"center"}
                    gap={1}
                    mt={1}
                  >
                    <Typography variant="body2" pt={0}>
                      <strong>Date of Issue of Certificate: </strong>
                    </Typography>
                    <ControlledTextField
                      name="date_of_issue"
                      control={control}
                      errors={errors}
                      type="date"
                      sx={{ width: "38%" }}
                      required
                    />
                  </Box>
                </Box>
              </form>
            </Box>

            <DataGrid
              rows={[...applications].sort((a, b) =>
                (a.board_roll_no ?? "").localeCompare(b.board_roll_no ?? "")
              )}
              columns={columns}
              rowHeight={40}
              getRowId={(row) => row.student_id}
              pageSizeOptions={[50, 100]}
              loading={loading}
              rowBufferPx={300}
              disableColumnFilter
              disableColumnMenu
              disableRowSelectionOnClick
              slots={{
                toolbar: GridToolbar,
                noRowsOverlay: () => <CustomNoRowsOverlay loading={loading} />,
              }}
              slotProps={{ toolbar: { showQuickFilter: true } }}
              sx={{
                maxWidth: "98vw",
                height: "65vh",

                "& .MuiDataGrid-row:hover": {
                  transform: "scale(1)", // Hover zoom effect
                  backgroundColor: "#f5f5f5", // Light background on hover
                  "& .MuiDataGrid-cell": {
                    color: "#2E186A", // Change text color on hover
                    fontWeight: "bold", // Bold text on hover
                  },
                },
                "& .MuiDataGrid-row.Mui-selected": {
                  backgroundColor: "#f0f0f0", // Active row background color
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#1e88e5", // Custom background color for header
                  // fontFamily: "Motiva Sans Bold",
                  color: "#2e186a", // Custom text color for header
                  fontSize: "1rem", // Increase font size of header
                  borderBottom: "2px solid #fff", // Add a border at the bottom of headers
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  textOverflow: "clip", // Prevent ellipsis from appearing
                  whiteSpace: "normal", // Ensure text wraps if it's too long
                  lineHeight: "1", // Adjust line height
                },
                "& .MuiDataGrid-columnHeader": {
                  padding: "0px 10px", // Add padding to header cells
                },
              }}
            />
          </Grid>
        </Grid>
      </Box>

      {tcdata && isProfileDialogOpen && (
        <PrintTCDialogBox
          isOpen={isProfileDialogOpen}
          onClose={onClose}
          tcdata={tcdata}
          onSuccess={onSuccess}
          certType={certType}
        />
      )}
    </>
  );
};

export default React.memo(IssueTC);
